module.exports = __webpack_public_path__ + "static/mobilenav-previousscreen-do-3e7f4bfd2be5b9848ee7317cb0062875.png";